export default __webpack_public_path__ + "static/media/reportIcon.1bac730d.svg";